import * as CookieConsent from 'vanilla-cookieconsent';

export function showCookiePreferences(): void {
  CookieConsent.showPreferences();
}

export function isThirdPartyMapsConsentGranted(): boolean {
  if (!CookieConsent.validConsent()) return false;
  return CookieConsent.acceptedCategory('third_party');
}
